// src/components/compatibilityMap.js

// --- YOU MUST DEFINE YOUR ACTUAL COMPATIBILITY RULES HERE ---
// This is an EXAMPLE structure. Populate it thoroughly.
// For each item (e.g., "sheath"), list the *allowed* values for other fields.
// If a field is not listed, it means all options for that field are considered compatible by default from this item's perspective.
// The `filterOptions` function will then check these relationships.
export const compatibilityMap = {
  bodice: {
    sheath: {
      neckline: [
        "v-shaped",
        "round",
        "square",
        "strapless",
        "boat",
        "halter",
        "strappy-v-neck",
        "sweetheart",
        "u-shaped",
        "surplice",
        "one-shoulder-neck",
        "cowl",
        "jewel",
        "illusion",
      ],
      skirt: ["a-line-straight", "pencil", "flared", "high-low", 'tiered'],
      sleeve: ["sleeveless", "cap", "short", "long"],
      backstyle: ["zipper", "button-up", "open", "v-back"],
    },
    blouson: {
      neckline: [
        "v-shaped",
        "round",
        "square",
        "strapless",
        "boat",
        "halter",
        "strappy-v-neck",
        "sweetheart",
        "u-shaped",
        "surplice",
        "one-shoulder-neck",
        "cowl",
        "jewel",
        "illusion",
      ],
      skirt: ["a-line-straight", "circle", "flared", "high-low", 'tiered'],
      sleeve: ["sleeveless", "long", "bishop", "bell"],
    },
    corset: {
      neckline: [
        "v-shaped",
        "round",
        "square",
        "strapless",
        "boat",
        "halter",
        "strappy-v-neck",
        "sweetheart",
        "u-shaped",
        "surplice",
        "one-shoulder-neck",
        "cowl",
        "jewel",
        "illusion",
      ],
      skirt: ["a-line-straight", "circle", "trumpet", "flared", "high-low", 'tiered'],
      sleeve: ["sleeveless", "cap"],
      backstyle: ["lace-up", "zipper", "open"],
    },
    empire: {
      neckline: [
        "v-shaped",
        "round",
        "square",
        "strapless",
        "boat",
        "halter",
        "strappy-v-neck",
        "sweetheart",
        "u-shaped",
        "surplice",
        "one-shoulder-neck",
        "cowl",
        "jewel",
        "illusion",
      ],
      skirt: ["a-line-straight", "flared", "circle", "high-low", 'tiered'],
      backstyle: ["zipper", "button-up", "open"],
    },
    peplum: {
      neckline: [
        "v-shaped",
        "round",
        "square",
        "strapless",
        "boat",
        "halter",
        "strappy-v-neck",
        "sweetheart",
        "u-shaped",
        "surplice",
        "one-shoulder-neck",
        "cowl",
        "jewel",
        "illusion",
      ],
      skirt: ["pencil", "a-line-straight", "flared", "high-low", 'tiered'],
      backstyle: ["zipper", "button-up"],
    },
    draped: {
      neckline: ["cowl", "v-shaped", "boat"],
      skirt: ["flared", "circle", "high-low", 'tiered'],
      backstyle: ["open", "keyhole", "u-back"],
    },
    asymmetrical: {
      neckline: ["one-shoulder-neck", "asymmetrical-neck"],
      skirt: ["high-low", "flared", "pencil", "high-low", 'tiered'],
      backstyle: ["open", "cross-back", "lace-up"],
    },
    wrapped: {
      neckline: ["v-shaped", "surplice"],
      skirt: ["a-line-straight", "flared", "pencil"],
      backstyle: ["zipper", "open"],
    },
    flared: {
      neckline: ["v-shaped", "round", "square", "sweetheart", "u-shaped"],
      skirt: ["a-line-straight", "circle", "flared", "high-low", 'tiered'],
      backstyle: ["zipper", "button-up", "v-back"],
    },
  },
  neckline: {
    "v-shaped": {
      bodice: [
        "sheath",
        "wrapped",
        "corset",
        "blouson",
        "peplum",
        "draped",
        "flared",
      ],
    },
    boat: { bodice: ["sheath", "corset", "blouson", "peplum", "draped"] },
    halter: { bodice: ["sheath", "corset", "blouson", "peplum"] },
    round: { bodice: ["sheath", "corset", "blouson", "peplum", "flared"] },
    "one-shoulder-neck": {
      bodice: ["sheath", "corset", "blouson", "peplum", "asymmetrical"],
    },
    "strappy-v-neck": { bodice: ["sheath", "corset", "blouson", "peplum"] },
    square: { bodice: ["sheath", "corset", "blouson", "peplum", "flared"] },
    "u-shaped": { bodice: ["sheath", "corset", "blouson", "peplum", "flared"] },
    illusion: {
      bodice: ["sheath", "corset", "blouson", "peplum"],
      backstyle: ["button-up", "zipper", "keyhole"],
    },
    sweetheart: { bodice: ["sheath", "corset", "blouson", "peplum", "flared"] },
    surplice: { bodice: ["sheath", "wrapped", "corset", "blouson", "peplum"] },
    cowl: { bodice: ["sheath", "blouson", "peplum", "draped"] },
    jewel: { bodice: ["sheath", "corset", "blouson", "peplum"] },
    strapless: { bodice: ["sheath", "corset", "blouson", "peplum"] },
    "asymmetrical-neck": { bodice: ["asymmetrical"] },
  },
  skirt: {
    pencil: {
      bodice: ["sheath", "peplum", "wrapped", "asymmetrical"],
      length: ["midi", "mini"],
    },
    trumpet: {
      bodice: ["sheath", "corset", "wrapped"],
      length: ["maxi", "midi"],
    },
    flared: {
      bodice: [
        "sheath",
        "blouson",
        "corset",
        "empire",
        "peplum",
        "draped",
        "asymmetrical",
        "wrapped",
        "flared",
      ],
    },
    "a-line-straight": {
      bodice: [
        "sheath",
        "blouson",
        "corset",
        "empire",
        "peplum",
        "wrapped",
        "flared",
      ],
    },
    "high-low": { bodice: ["corset", "draped", "asymmetrical"] },
    circle: { bodice: ["blouson", "corset", "empire", "draped", "flared"] },
  },
  sleeve: {
    sleeveless: {},
    cap: { bodice: ["sheath", "corset"] },
    short: { bodice: ["sheath"] },
    long: { bodice: ["sheath", "blouson"] },
    bishop: { bodice: ["blouson"] },
    bell: { bodice: ["blouson"] },
  },
  backstyle: {
    zipper: {
      bodice: ["sheath", "corset", "empire", "peplum", "wrapped", "flared"],
    },
    "button-up": { bodice: ["sheath", "empire", "peplum", "flared"] },
    "lace-up": { bodice: ["corset", "asymmetrical"] },
    open: {
      bodice: [
        "sheath",
        "corset",
        "empire",
        "draped",
        "asymmetrical",
        "wrapped",
      ],
    },
    cross: { neckline: ["halter", "strappy-v-neck", "u-shaped"] },
    "v-back": { bodice: ["flared", "draped", "sheath"] },
    "u-back": { neckline: ["round", "u-shaped", "boat"] },
    keyhole: { neckline: ["round", "halter", "jewel"] },
  },
};

export const filterOptions = (
  field,
  options,
  selectedValues,
  currentCompatibilityMap
) => {
  if (!options) return [];
  if (!currentCompatibilityMap) {
    // console.warn("Compatibility map not provided to filterOptions for field:", field);
    return options.map((opt) => ({ ...opt, disabled: false }));
  }

  let availableOptions = options.map((opt) => ({
    ...opt,
    disabled: false,
    reason: "",
  }));

  for (const [otherField, selectedValueInOtherField] of Object.entries(
    selectedValues
  )) {
    if (otherField === field || !selectedValueInOtherField) continue;

    // Filter THIS field based on selections in OTHER fields
    const restrictionsFromOtherOnThisField =
      currentCompatibilityMap[otherField]?.[selectedValueInOtherField]?.[field];
    if (restrictionsFromOtherOnThisField) {
      if (restrictionsFromOtherOnThisField === "all") {
        // No specific restriction, all options of 'field' are fine with 'selectedValueInOtherField'
      } else {
        availableOptions = availableOptions.filter((opt) =>
          restrictionsFromOtherOnThisField.includes(opt.value)
        );
      }
    }

    // Filter THIS field based on how options in THIS field would restrict OTHER ALREADY SELECTED fields
    // (This is important: an option for 'field' is only valid if it's compatible with *all* existing selections)
    availableOptions = availableOptions.filter((currentOptionForThisField) => {
      const restrictionsFromThisOptionOnOtherField =
        currentCompatibilityMap[field]?.[currentOptionForThisField.value]?.[
          otherField
        ];
      if (restrictionsFromThisOptionOnOtherField) {
        if (restrictionsFromThisOptionOnOtherField === "all") return true;
        return restrictionsFromThisOptionOnOtherField.includes(
          selectedValueInOtherField
        );
      }
      return true; // No restriction specified by this option for the otherField, so it's compatible in this direction
    });
  }

  // --- Specific complex interdependencies (like backstyle needing to be compatible with BOTH bodice and neckline) ---
  if (field === "backstyle") {
    const { bodice, neckline } = selectedValues;
    if (bodice || neckline) {
      availableOptions = availableOptions.filter((backstyleOption) => {
        let isCompatibleWithBodice = true;
        if (bodice) {
          isCompatibleWithBodice =
            currentCompatibilityMap.bodice?.[bodice]?.backstyle?.includes(
              backstyleOption.value
            ) ?? !currentCompatibilityMap.bodice?.[bodice]?.backstyle; // True if no specific restriction or list includes it
        }

        let isCompatibleWithNeckline = true;
        if (neckline) {
          isCompatibleWithNeckline =
            currentCompatibilityMap.neckline?.[neckline]?.backstyle?.includes(
              backstyleOption.value
            ) ?? !currentCompatibilityMap.neckline?.[neckline]?.backstyle; // True if no specific restriction or list includes it
        }

        // If a bodice and neckline are selected, they also need to be compatible with each other
        // for any backstyle to be truly valid in that combination.
        // This check might be more about the validity of the bodice/neckline pair itself.
        let bodiceNecklinePairValid = true;
        if (bodice && neckline) {
          const bodiceAllowsNeckline =
            currentCompatibilityMap.bodice?.[bodice]?.neckline?.includes(
              neckline
            ) ?? !currentCompatibilityMap.bodice?.[bodice]?.neckline;
          const necklineAllowsBodice =
            currentCompatibilityMap.neckline?.[neckline]?.bodice?.includes(
              bodice
            ) ?? !currentCompatibilityMap.neckline?.[neckline]?.bodice;
          // This simplified check assumes if one direction is defined, it must be met. If neither defines, assume compatible.
          // A more robust way is if map.bodice.bodiceVal.neckline is defined, it MUST include selectedNeckline.
          let bnCompatible = true;
          if (
            currentCompatibilityMap.bodice?.[bodice]?.neckline &&
            !currentCompatibilityMap.bodice[bodice].neckline.includes(neckline)
          )
            bnCompatible = false;
          if (
            currentCompatibilityMap.neckline?.[neckline]?.bodice &&
            !currentCompatibilityMap.neckline[neckline].bodice.includes(bodice)
          )
            bnCompatible = false;

          bodiceNecklinePairValid = bnCompatible;
        }

        return (
          isCompatibleWithBodice &&
          isCompatibleWithNeckline &&
          bodiceNecklinePairValid
        );
      });
    }
  }

  return availableOptions;
};
